import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Link } from "react-router-dom";
import { getData } from '../API';
import * as XLSX from 'xlsx';
import { parseISO, format, parse } from 'date-fns';
function GroupedReports() {
  const formattedDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'MMMM d, yyyy');
  };
  const [filteredData, setFilteredData] = useState([]);
  const [establishData, setEstablishData] = useState([]);
  const [ownerTypeData, setOwnerTypeData] = useState([]);
  const [allSurveyorsData, setAllSurveyorsData] = useState([]);
  const [allWardData, setAllWardData] = useState([]);
  const [allZoneData, setAllZoneData] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const gridRef = useRef();
 
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem('filters');
    if (savedFilters) {
      return JSON.parse(savedFilters);
    }
    return {
      establishmentTypeId: '',
      ownerTypeId: '',
      userId: '',
      fromDate: getInitialFromDate(),
      toDate: getCurrentDate(),
      zoneId: '',
      wardNo: ''
    };
  };

  const [filters, setFilters] = useState(getInitialFilters());

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchData(filters);
    getAllData();
    getAllOwnerType();
    getAllSurveyorType();
    getZoneType();
  }, []);

  useEffect(() => {
    if (filters.zoneId) {
      getWardType(filters.zoneId);
    } else {
      setAllWardData([]); // Clear ward data when zone is deselected
    }
  }, [filters.zoneId]);

  useEffect(() => {
    const handleResize = () => {
      gridRef.current.api.sizeColumnsToFit();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('filters');
      const initialFilters = {
        establishmentTypeId: '',
        ownerTypeId: '',
        userId: '',
        fromDate: getInitialFromDate(),
        toDate: getCurrentDate(),
        zoneId: '',
        wardNo: ''
      };
      setFilters(initialFilters);
      fetchData(initialFilters);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('filters', JSON.stringify(filters));
  }, [filters]);

  const buildQueryParams = (filters) => {
    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });
    return queryParams.toString();
  };

  // const fetchData = async (filters) => {
  //   try {
  //     const { fromDate, toDate } = filters;
  //     const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
  //     const formattedToDate = new Date(toDate).toISOString().split('T')[0];
  //     const updatedFilters = { ...filters, fromDate: formattedFromDate, toDate: formattedToDate };

  //     const queryParams = buildQueryParams(updatedFilters);
  //     const data = await getData(`SurveyDetails/FilteredSurveys?${queryParams}`);
  //     setFilteredData(data)
  //     // const data = await res.json();

  //     // if (data.status === 200) {
  //     //   setisLoading(false);
  //     //   setFilteredData(Array.isArray(data) ? data : []);
  //     // } else {
  //     //   setisLoading(true);
  //     //   setFilteredData([]);
  //     // }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     setisLoading(true);
  //     setFilteredData([]);
  //   }
  // };

  const fetchData = async (filters) => {
    try {
      const { fromDate, toDate } = filters;
      const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
      const formattedToDate = new Date(toDate).toISOString().split('T')[0];
      const updatedFilters = { ...filters, fromDate: formattedFromDate, toDate: formattedToDate };
  
      const queryParams = buildQueryParams(updatedFilters);
      const data = await getData(`ParentGuid/GroupBySurvey?${queryParams}`);
      setFilteredData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setFilteredData([]); // Ensure it is set to an empty array on error
    }
  };
  const getAllData = async () => {
    try {
      const res = await getData('SurveyMasters/EstablishmentTypes');
      // const response = await res.json();
      setEstablishData(res.data);
    } catch (error) {
      console.error('Error fetching establishment data:', error);
      setEstablishData([]);
    }
  };

  const getAllOwnerType = async () => {
    try {
      const res = await getData('SurveyMasters/OwnershipTypes');
      // const response = await res.json();
      setOwnerTypeData(res.data);
    } catch (error) {
      console.error('Error fetching owner type data:', error);
      setOwnerTypeData([]);
    }
  };

  const getAllSurveyorType = async () => {
    try {
      const res = await getData('SurveyDetails/GetAllSureveyors');
      // const data = await res.json();

      if (Array.isArray(res)) {
        setAllSurveyorsData(res);
      } else {
        setAllSurveyorsData([]);
      }
    } catch (error) {
      console.error('Error fetching surveyors:', error);
      setAllSurveyorsData([]);
    }
  };

  const getWardType = async (zoneId) => {
    try {
      const res = await getData(`SurveyMasters/GetAllWards?zoneId=${zoneId}`);
      // const response = await res.json();
      setAllWardData(res.data);
    } catch (error) {
      console.error('Error fetching ward data:', error);
      setAllWardData([]);
    }
  };

  const getZoneType = async () => {
    try {
      const res = await getData('SurveyMasters/UCCZoneMasters');
      // const response = await res.json();
      setAllZoneData(res.data);
    } catch (error) {
      console.error('Error fetching zone data:', error);
      setAllZoneData([]);
    }
  };

  function getInitialFromDate() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    return sevenDaysAgo.toISOString().split('T')[0];
  }

  function getCurrentDate() {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleZoneChange = (e) => {
    const { name, value } = e.target;
    // setFilters({ ...filters, zoneId: value, wardNo: '' });
    setFilters(prevFilters => ({
      ...prevFilters,
      zoneId: value,
      wardNo: '' // Clear the ward filter
    }));
  };

  const handleSearch = () => {
    fetchData(filters);
  };

  const FilteredParentdata=filteredData.filter(item => item.parentGuid !== null&&item.parentGuid !=="");

  console.log("filtered parent data",FilteredParentdata)

  const downloadExcel = () => {
    const tableHeaders = ["S.No", "Owner Name","Surveyor Date","Owner Contact No", "Property House No.", "Address",
      "Establishment Type","OwnerShip Type","Muncipal RegNo","Registration StartDate","Registration EndDate","House No","Email Id","MinWaste Qty",
      "Commercial Type","Rate Type","Display Rate","Tenant Name","Tenant ContactNo","No Of Members","Landmark","Remarks",
      "Zone","Ward","Rate Category Name","Rate SubCategory Name","Extra Area","Municipal CommercialNo","Fixed Value"
    ];
    const tableData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Owner Name": item.ownerName,
      "Surveyor Date": new Date(item.createdDate).toLocaleDateString(),
      "Owner Contact No": item.ownerContactNo,
      "Property House No.": item.houseNo,
      "Address": item.address,
      "Establishment Type":item.establishmentType,
      "OwnerShip Type":item.ownerShipType,
      "Muncipal RegNo":item.muncipalRegNo,
      "Registration StartDate": item.registrationStartDate &&formattedDate(item.registrationStartDate),
      "Registration EndDate": item.registrationEndDate&&formattedDate(item.registrationEndDate),
      "House No":item.houseNo,
      "Email Id":item.emailId,
      "minWasteQty":item.minWasteQty,
      "Commercial Type":item.commercialType,
      "Rate Type":item.rateType,
      "Display Rate":item.displayRate,
      "Tenant Name":item.tenantName,
      "Tenant ContactNo":item.tenantContactNo,
      "No Of Members":item.noOfMembers,
      "Landmark":item.landmark,
      "Remarks":item.remarks,
      "Zone":item.zoneName,
      "Ward":item.wardNo,
      "Rate Category Name":item.rateCategoryName,
      "Rate SubCategory Name":item.rateSubCategoryName,
      "Extra Area":item.extraArea,
      "Municipal CommercialNo":item.municipalCommercialNo,
      "Fixed Value":item.fixedValue,

    }));
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A1' });
  
    // Set column widths
    worksheet['!cols'] = [
      { wpx: 30 },  // Width for S.No
      { wpx: 150 }, // Width for Owner Name
      { wpx: 100 }, // Width for Surveyor Date
      { wpx: 100 }, // Width for Owner Contact No
      { wpx: 120 }, // Width for Property House No.
      { wpx: 200 }, // Width for Address
      { wpx: 150 }, // Width for establishmentType
      { wpx: 150 }, // Width for ownerShipType
      { wpx: 120 }, // Width for muncipalRegNo
      { wpx: 120 }, // Width for registrationStartDate
      { wpx: 120 }, // Width for houseNo
      { wpx: 200 }, // Width for emailId
      { wpx: 100 }, // Width for minWasteQty
      { wpx: 150 }, // Width for commercialType
      { wpx: 100 }, // Width for rateType
      { wpx: 100 }, // Width for displayRate
      { wpx: 150 }, // Width for tenantName
      { wpx: 100 }, // Width for tenantContactNo
      { wpx: 100 }, // Width for noOfMembers
      { wpx: 200 }, // Width for landmark
      { wpx: 200 }, // Width for remarks
      { wpx: 100 }, // Width for zoneName
      { wpx: 100 }, // Width for wardNo
      { wpx: 150 }, // Width for rateCategoryName
      { wpx: 150 }, // Width for rateSubCategoryName
      { wpx: 100 }, // Width for extraArea
      { wpx: 150 }, // Width for municipalCommercialNo
      { wpx: 100 }  // Width for fixedValue
    ];
    // const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports Data");
    XLSX.writeFile(workbook, "ReportsData.xlsx");
  };

  const columnDefs = [
    {
      headerName: "S.No",
      field: "sNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      headerClass: "grid-header",
    },
    {
      field: "establishmentType",
      headerName: "Type of Establishment",
      headerClass: "grid-header",
      

    },
    {
      field: "ownerName",
      headerName: "Owner Name",
      headerClass: "grid-header",
    },
    {
      field: "ownerContactNo",
      headerName: "Owner Contact No",
      headerClass: "grid-header",
    },
    { 
      headerName: 'Surveyor Date', 
      field: 'createdDate',
      valueFormatter: params => new Date(params.value).toLocaleDateString() ,
      headerClass: "grid-header",
    },
    {
      field: "houseNo",
      headerName: "Property House No.",
      headerClass: "grid-header",
    },
    {
      field: "address",
      headerName: "Address",
      headerClass: "grid-header",
    },
    {
      field: "action",
      headerName: "Action",
      cellRenderer: (params) => {
       
        const secondaryId = params.data.parentGuid ; 
        const url = (secondaryId !== null && secondaryId !== undefined&&secondaryId !=="")? `/grouped-reports-view/${secondaryId}`:`/grouped-reports-view/a`;
        // const url = (secondaryId !== null && secondaryId !== undefined)&& `/grouped-reports/${secondaryId}`;

        return (
          <button
            className="btn btn-sm rounded-3"
            style={{ boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)', background: "#9CA3AF", fontWeight: 600 }}
          >
            <Link to={url} className="text-white">
              View more
            </Link>
          </button>
        );
      },
      headerClass: "grid-header",
      cellClass: "no-right-border",
      suppressMenu: true,
      sortable: false
    },
  ];

  const defaultColDef = {
    sortable: true,
    resizable: true,
    flex: 1
  };

  return (
    <div>
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="row align-items-center mb-3">
            <div className="col-md-12">
              <h1 className="title_pages">Reports</h1>
            </div>
          </div>
          <div className='filters'>
            <div className='row align-items-end'>
              <div className="col-md-12">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Type of Establishment</label>
                      <select type="select" className='form-select' name="establishmentTypeId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.establishmentTypeId}>
                        <option value="">Select</option>
                        {establishData.map((establishment) => (
                          <option key={establishment.establishmentTypeId} value={establishment.establishmentTypeId}>{establishment.establishmentTypeName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Type of Owner</label>
                      <select type="select" className='form-select' name="ownerTypeId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.ownerTypeId}>
                        <option value="">Select</option>
                        {ownerTypeData.map((ownerType) => (
                          <option key={ownerType.ownershipTypeId} value={ownerType.ownershipTypeId}>{ownerType.ownershipTypeName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Surveyor name</label>
                      <select type="select" className='form-select' name="userId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.userId}>
                        <option value="">Select</option>
                        {allSurveyorsData.length > 0 ? (
                          allSurveyorsData.map((surveyor) => (
                            surveyor.displayName!=null&& <option key={surveyor.userId} value={surveyor.userId}>{surveyor.displayName}</option>
                          ))  
                        ) : (
                          <option value="">No surveyors found</option>
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Zone</label>
                      <select type="select" className='form-select' name="zoneId" onChange={handleZoneChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.zoneId}>
                        <option value="">Select</option>
                        {allZoneData.map((zone) => (
                          <option key={zone.uccZoneId} value={zone.uccZoneId}>{zone.zoneName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Ward</label>
                      <select type="select" className='form-select' name="wardNo" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.wardNo}>
                        <option value="">Select</option>
                        {allWardData.map((ward) => (
                          <option key={ward.wardId} value={ward.wardId}>{ward.wardNo}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>From Date</label>
                      <input 
                      style={{boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'}}
                       type="date" 
                       className='form-control' 
                       name="fromDate" 
                       value={filters.fromDate} 
                       onChange={handleFilterChange}
                       max={new Date().toISOString().split('T')[0]}
                       />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>To Date</label>
                      <input style={{boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'}}
                       type="date" 
                       className='form-control' 
                       name="toDate" 
                       value={filters.toDate} 
                       onChange={handleFilterChange}
                      max={new Date().toISOString().split('T')[0]}
                        
                        />
                    </div>
                  </div>
                  <div className="col-md-3 mb-3 text-start d-flex gap-2">
                  <button
                      className='btn px-4'
                      onClick={handleSearch} 
                      style={{ background: "#a7252ced", border: "none", color: "white",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }}
                    >
                      SEARCH
                    </button>
                    <button
                      className='btn px-4'
                      onClick={() => {
                        localStorage.removeItem('filters');
                        const initialFilters = {
                          establishmentTypeId: '',
                          ownerTypeId: '',
                          userId: '',
                          fromDate: getInitialFromDate(),
                          toDate: getCurrentDate(),
                          zoneId: '',
                          wardNo: ''
                        };
                        setFilters(initialFilters);
                        fetchData(initialFilters); // Fetch all data after resetting filters
                      }}
                      style={{ background: "#a7252ced", border: "none", color: "white",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }}
                    >
                      Reset
                    </button>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='text-start mb-3 mt-3'>
            <button className='btn ' onClick={downloadExcel} style={{background:"#9CA3AF", color:"white",boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'}}>Excel <i className="fa-solid fa-download ms-1"></i></button>
          </div>
          <div className="card shadow">
            <div className="card-body">
              <div className='table-responsive'>
                <div className="ag-theme-alpine" style={{ height: "100%", width: "100%", margin: "auto" }}>
                  <AgGridReact
                    ref={gridRef}
                    domLayout='autoHeight'
                    defaultColDef={defaultColDef}
                    rowData={FilteredParentdata}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={45}
                    paginationPageSizeSelector={[10, 20, 50]} // Ensure 10 is in the selector options
                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading...</span>'}
                    // overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">Loading Please Wait.....</span>'}
                    onGridReady={(params) => params.api.sizeColumnsToFit()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default GroupedReports;
